export default __webpack_public_path__ + "svg/calendar/2026/9/octubre.svg?9813d34b";